(function () {
  var lastScroll = 0;

  // breathing room above the options — a little more on mobile.
  function getExtraGap() {
    return window.innerWidth < 768 ? 60 : 24;
  }

  // measure the real sticky header height at scroll time.
  function getStickyHeaderHeight() {
    var header = document.querySelector('.shopify-section.section-header');
    if (header) {
      var pos = getComputedStyle(header).position;
      if (pos === 'sticky' || pos === 'fixed') {
        return header.getBoundingClientRect().height;
      }
    }
    // fallback: scan for any element pinned to the very top
    var pinned = [...document.querySelectorAll('header, [class*="header"], [class*="sticky"]')];
    var max = 0;
    pinned.forEach(function (el) {
      var s = getComputedStyle(el);
      var r = el.getBoundingClientRect();
      if ((s.position === 'fixed' || s.position === 'sticky') && r.top <= 5 && r.bottom > max) {
        max = r.bottom;
      }
    });
    return max;
  }

  function scrollToOptions() {
    // uniform target: the top of the whole OPTIS options block,
    // so every product lands in the same, consistent place.
    var block = document.querySelector('.bss-po-product-page');
    var err = document.querySelector('.bss-error-msg');
    var target = block || (err && err.closest('.po-option--container')) || err;
    if (!target) return;

    var now = Date.now();
    if (now - lastScroll < 800) return; // debounce
    lastScroll = now;

    var offset = getStickyHeaderHeight() + getExtraGap();
    var top = target.getBoundingClientRect().top + window.pageYOffset - offset;
    window.scrollTo({ top: Math.max(top, 0), behavior: 'smooth' });
  }

  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var added = mutations[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var n = added[j];
        if (n.nodeType === 1 &&
            (n.classList && n.classList.contains('bss-error-msg') ||
             (n.querySelector && n.querySelector('.bss-error-msg')))) {
          scrollToOptions();
          return;
        }
      }
    }
  });

  function start() {
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.body) start();
  else document.addEventListener('DOMContentLoaded', start);
})();